var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useMemo, useReducer } from "react";
import styled from "styled-components";
import { TableFooter, TableHeaderRow, TableRow } from ".";
import { useTableContext } from "./context";
import { useTableUpdateDispatch } from "./updateContext";
// const data = [{ ogIdx: 1, cells: { header1: { value: 1 }, header2: { value: 2 } } }];
var ROW_HEIGHT = 35;
var TableContainer = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-height: 100%;\n  padding-bottom: ", ";\n  position: relative;\n  overflow: hidden;\n"], ["\n  max-height: 100%;\n  padding-bottom: ", ";\n  position: relative;\n  overflow: hidden;\n"])), ROW_HEIGHT);
var TableBody = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, gridTemplateColumns = _a.gridTemplateColumns;
    return "\n    height: calc(100% - ".concat(ROW_HEIGHT, "px);\n    display: grid;\n    grid-template-columns: ").concat(gridTemplateColumns, ";\n    grid-template-rows: ").concat(ROW_HEIGHT, "px 1fr;\n    box-sizing: border-box;\n    color: ").concat(theme.colorContent(), ";\n    overflow: scroll;\n    padding-bottom: 2px;\n  ");
});
var TableData = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n", "\n"], ["\n", "\n"])), function (_a) {
    var theme = _a.theme, gridTemplateColumns = _a.gridTemplateColumns, numRows = _a.numRows;
    return "\n  height: 100%;\n  display: grid;\n  width: 100%;\n  grid-column: 1 / -1;\n  grid-template-columns: ".concat(gridTemplateColumns, ";\n  grid-template-rows: repeat(").concat(numRows, ", ").concat(ROW_HEIGHT, "px);\n  box-sizing: border-box;\n  color: ").concat(theme.colorContent(), ";\n  overflow: scroll;\n  padding-bottom: 2px;\n");
});
var defaultNumRows = 80;
var defaultState = {
    values: {},
    Rows: [],
    numRows: defaultNumRows,
    current: Math.floor(defaultNumRows / 2),
};
var dispatchFn = function (state, action) {
    switch (action.type) {
        case "UPDATE_ROWS": {
            var _a = action.payload, Rows = _a.Rows, values = _a.values;
            return __assign(__assign({}, state), { values: values, Rows: Rows });
        }
        case "HANDLE_SCROLL": {
            var minCurrent = Math.floor(state.numRows / 2);
            var maxCurrent = state.Rows.length - Math.floor(state.numRows / 2);
            var nextCurrent = action.payload;
            if (nextCurrent < minCurrent) {
                nextCurrent = minCurrent;
            }
            if (nextCurrent > maxCurrent) {
                nextCurrent = maxCurrent;
            }
            if (state.current === nextCurrent) {
                return state;
            }
            else {
                return __assign(__assign({}, state), { current: nextCurrent, Rows: Array.from(state.Rows) });
            }
        }
        default:
            return __assign({}, state);
    }
};
export var TableComponent = function (_a) {
    var setUpdateHandler = _a.setUpdateHandler;
    var _b = useTableContext(), headers = _b.headers, rows = _b.rows;
    var tableUpdateDispatch = useTableUpdateDispatch();
    var _c = useReducer(dispatchFn, defaultState), state = _c[0], dispatch = _c[1];
    var handleUpdate = useCallback(function (updates) {
        console.log({ updates: updates });
        if (updates) {
            tableUpdateDispatch({
                type: "SET_UPDATES",
                payload: { updates: updates }
            });
        }
    }, [tableUpdateDispatch]);
    useEffect(function () {
        setUpdateHandler(handleUpdate);
    }, [setUpdateHandler, handleUpdate]);
    var minCurrent = useMemo(function () {
        return Math.floor(state.numRows / 2);
    }, [state.numRows]);
    var maxCurrent = useMemo(function () {
        return Math.max(state.Rows.length - Math.floor(state.numRows / 2), 0);
    }, [state.Rows, state.numRows]);
    useEffect(function () {
        var values = __assign({}, state.values);
        var Rows = Array.from(state.Rows);
        var hasUpdate = false;
        Object.entries(rows).map(function (_a, index) {
            var key = _a[0], row = _a[1];
            if (values[key] !== row) {
                hasUpdate = true;
                // update Cell
                values[key] = row;
                Rows[index] = React.createElement(TableRow, { rowStart: index + 1, key: key, cells: row.cells, selected: row.selected, rowId: "test".concat(index) });
            }
        });
        if (hasUpdate) {
            dispatch({
                type: "UPDATE_ROWS",
                payload: { values: values, Rows: Rows },
            });
        }
    }, [state.values, state.Rows, rows]);
    var gridTemplateColumns = useMemo(function () {
        return headers
            .map(function (header) { return (header.width ? "".concat(header.width, "px") : "calc(".concat(header.label.length, "ch + 20px)")); })
            .join(" ");
    }, [headers]);
    var handleScroll = useCallback(function (e) {
        var topIdx = Math.floor(e.target.scrollTop / ROW_HEIGHT);
        if (Math.abs(topIdx - state.current) > state.numRows / 3) {
            dispatch({
                type: "HANDLE_SCROLL",
                payload: topIdx,
            });
        }
    }, [state]);
    var bodyDisplay = useMemo(function () {
        var start = state.current - minCurrent;
        if (state.current > maxCurrent) {
            start = maxCurrent;
        }
        var end = start + state.numRows;
        return state.Rows.slice(start, end);
    }, [state, minCurrent, maxCurrent]);
    return (React.createElement(TableContainer, null,
        React.createElement(TableBody, { gridTemplateColumns: gridTemplateColumns, numRows: state.Rows.length },
            React.createElement(TableData, { onScroll: handleScroll, gridTemplateColumns: gridTemplateColumns, numRows: state.Rows.length }, bodyDisplay),
            React.createElement(TableHeaderRow, null)),
        React.createElement(TableFooter, { numRows: state.Rows.length })));
};
var templateObject_1, templateObject_2, templateObject_3;
